import { Divider, Drawer, Input, Space, Slider, Checkbox, Button, Tooltip, Select, Spin } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import ImageSelect from "../../ImageSelect";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import LinkUI from "../../UI/LinkUI";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import Html from "../../../utils/Html";
import { previewLink, tt_name_block_warning, tt_toi_bg_align, tt_tov_align_center, tt_tov_align_left, tt_tov_align_right, tt_tov_bg_padding_x, tt_tov_bg_padding_y, tt_tov_bg_video, tt_tov_border_radius, tt_tov_txt_padding_x, tt_tov_txt_padding_y } from "../../../utils/Utils";
import { fetchImage } from "../../../utils/Api";
import RichTextEditor from "../../UI/RichTextEditor";
import LinkPicker from "../../../globals/styles/LinkPicker";
import SliderInput from "../../UI/SiderInput";
import PositionAlign from "../../UI/PositionAlign";
import MobileSelector from "../../UI/MobileSelector";
export default function TextOverVideo(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [content, setContent] = useState(props.content);
    const [mobile, setMobile] = useState(false)

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        background_video = "",
        background_colour = 0,
        text_container = true,
        text_background_colour = 0,
        text_background_radius = 0,
        width = 60,
        align = "center",
        textAlign = "center",
        padding_x = 10,
        padding_y = 10,
        bg_padding_x = 10,
        bg_padding_y = 30,
        heading = "Text Over Video",
        heading_preset = 0,
        paragraph = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tincidunt enim vel lectus egestas hendrerit. Sed at tempus ante. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
        paragraph_preset = 0,
        button_url = "",
        button_label = "",
        button_type = 0,
        button_tab = true,
        button_block = false,
        link_id = 0,

        // NEW 
        bg_height_enabled = false,
        bg_height = 500,
        align_content = "start",

        allow_mobile_overrides = false,
        mobile_align_content = "start",
        mobile_bg_height_enabled = false,
        mobile_bg_height = 500,


    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const linkOut = () => {
        if (button_url) {
            window.open(previewLink(button_url), (button_tab) ? "_blank" : "_self");
        }
    }

    const drawRender = () => {
        let _video = {
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            overflow: "hidden",
            zIndex: -1,
            backgroundColor: getColor(text_background_colour, template),
        }

        let _style = {
            backgroundColor: getColor(text_background_colour, template),
            borderRadius: text_background_radius + "px",
            padding: padding_y + "px " + padding_x + "px",
            maxWidth: (1248 * (width / 100)) + "px",
            alignSelf: "flex-end",
            textAlign: textAlign
        }

        let bg_style = {
            zIndex: 1,
            position: "relative",
        }

        let _align = {
            display: "flex",
            flexDirection: "column",
            height : "100%",
            justifyContent : align_content,
        }

        if (bg_height_enabled && view === "desktop") {
            bg_style.height = bg_height + "px";
            bg_style.overflow = "hidden";
        }

        if (allow_mobile_overrides && view !== "desktop") {
            if (mobile_bg_height_enabled) {
                bg_style.height = mobile_bg_height + "px";
                bg_style.overflow = "hidden";
                _align.justifyContent = mobile_align_content
            }
        }


        switch (align) {
            case "center":
                _style.alignSelf = "center";
                break;
            case "right":
                _style.alignSelf = "flex-end";
                break;
            default:
                _style.alignSelf = "flex-start";
                break;
        }


        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={bg_style}>
                    {(background_video && <video style={_video} className="background-video" autoPlay loop muted>
                        <source src={fetchImage(background_video)} type="video/webm" />
                        Your browser does not support the video tag.
                    </video>)}
                    <div style={{"height" : "100%", "padding": bg_padding_y + "px " + bg_padding_y + "px", "background": (background_video) ? "initial" : getColor(background_colour, template) }}>
                        <div className={(text_container) ? "child-preview-container" : ""} style={_align}>
                            <div style={_style}>
                                {(heading &&
                                    <h2 style={{ "display": "block" }} className={"bm-txt-" + heading_preset} >
                                        {heading}
                                    </h2>
                                )}
                                {(paragraph &&
                                    <p className={"bm-txt-" + paragraph_preset} >
                                        <Html anchor={"bm-lnkin-" + link_id} html={paragraph} />
                                    </p>
                                )}

                                {(button_label &&
                                    <div style={{ "display": "block" }}>
                                        <div className="shim" /><div className="shim" />
                                        <Button block={button_block} onClick={() => linkOut()} className={"bm-btn-" + button_type} >{button_label}</Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const formatter = (value) => `${value}%`;


    const drawMobile = () => {

        return (
            <>
                {/* <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={bg_height}>ENABLED MOBILE OVERIDES?</Tooltip></Divider> */}
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />

                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    {/* HEIGHT */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={bg_height}>BACKGROUND HEIGHT</Tooltip></Divider>
                    <div className="float-flex">
                        <SliderInput
                            width={90}
                            min={0}
                            max={1000}
                            onChange={(_v) => setData({ ...data, "mobile_bg_height": _v })}
                            disabled={!mobile_bg_height_enabled}
                            value={mobile_bg_height}
                        />
                        <Checkbox onChange={(e) => setData({ ...data, "mobile_bg_height_enabled": e.target.checked })} checked={mobile_bg_height_enabled}><small>Constrain?</small></Checkbox>
                    </div>
                    <div className="shim" /><div className="shim" />

                   
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">POSITION TEXT</Divider>
                    <Select disabled={!mobile_bg_height_enabled} value={mobile_align_content} onChange={(e) => setData({ ...data, "mobile_align_content": e })} size="small" style={{ "width": "100%" }} >
                        <Select.Option key="start" value="start"><small>Top</small></Select.Option>
                        <Select.Option key="center" value="center"><small>Middle</small></Select.Option>
                        <Select.Option key="end" value="end"><small>Bottom</small></Select.Option>
                    </Select>
                    <div className="shim" /> <div className="shim" />


                </Spin>
            </>
        )
    }

    const drawDesktop = () => {
        return (
            <>

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={tt_tov_bg_video}>BACKGROUND VIDEO</Tooltip></Divider>
                <ImageSelect video width={235} onChange={(_v) => setData({ ...data, "background_video": (_v) ? _v : "" })} path={background_video} />

                <div className="shim" /><div className="shim" />
                {/* HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={bg_height}>BACKGROUND HEIGHT</Tooltip></Divider>
                <div className="float-flex">
                    <SliderInput
                        width={90}
                        min={0}
                        max={2000}
                        onChange={(_v) => setData({ ...data, "bg_height": _v })}
                        disabled={!bg_height_enabled}
                        value={bg_height}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "bg_height_enabled": e.target.checked })} checked={bg_height_enabled}><small>Constrain?</small></Checkbox>
                </div>
                <div className="shim" /><div className="shim" />

                {/* BACKGROUND IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND VIDEO PADDING</Divider>
                <div className="float-flex">
                    <div>&nbsp;</div>
                    <Space>
                        <BMInput value={bg_padding_x} onChange={(_v) => setData({ ...data, "bg_padding_x": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_tov_bg_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={bg_padding_y} onChange={(_v) => setData({ ...data, "bg_padding_y": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_tov_bg_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT MAX WIDTH / POSITION</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "150px" }}
                        tooltip={{
                            formatter,
                        }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        value={width}
                    />
                    <Space>
                        <div><Tooltip placement="left" title={tt_tov_align_left}><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip placement="left" title={tt_tov_align_center}><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip placement="left" title={tt_tov_align_right}><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">POSITION TEXT</Divider>
                <Select disabled={!bg_height_enabled} value={align_content} onChange={(e) => setData({ ...data, "align_content": e })} size="small" style={{ "width": "100%" }} >
                    <Select.Option key="start" value="start"><small>Top</small></Select.Option>
                    <Select.Option key="center" value="center"><small>Middle</small></Select.Option>
                    <Select.Option key="end" value="end"><small>Bottom</small></Select.Option>
                </Select>


                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "textAlign": "left" })} style={{ "color": (textAlign === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "textAlign": "center" })} style={{ "color": (textAlign === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "textAlign": "right" })} style={{ "color": (textAlign === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_tov_txt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip placement="left" title={tt_tov_txt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={text_background_colour} onChange={(_v) => setData({ ...data, "text_background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT BG BORDER RADIUS</Divider>
                <BMInput width={"40px"} value={text_background_radius} onChange={(e) => setData({ ...data, "text_background_radius": e })} number min={0} max={1000} prefix={<Tooltip title={tt_tov_border_radius}>RADIUS</Tooltip>} />
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                    <PresetPicker value={heading_preset} onChange={(e) => setData({ ...data, "heading_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "heading": e.target.value })} value={heading} placeholder="Headline text..." />
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                    <PresetPicker value={paragraph_preset} onChange={(e) => setData({ ...data, "paragraph_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH</Divider>
                    <RichTextEditor container={container} link_id={link_id} background_colour={text_background_colour} padding_x={padding_x} padding_y={padding_y} paragraph_preset={paragraph_preset} text_align={textAlign} width={(1248 * (width / 100))} value={paragraph} onChange={(_v) => setData({ ...data, "paragraph": _v })} />
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON URL</Divider>
                <LinkUI value={button_url} onChange={(e) => setData({ ...data, "button_url": e })} />
                <div className="shim" /> <div className="shim" /><div className="shim" /> <div className="shim" />
                <div style={{ "marginTop": "-15px" }} className="float-flex">
                    <Checkbox disabled={(!button_label)} checked={button_block} onChange={(e) => setData({ ...data, "button_block": e.target.checked })} ><small>Fit Container?</small></Checkbox>
                    <Checkbox disabled={(!button_url)} checked={button_tab} onChange={(e) => setData({ ...data, "button_tab": e.target.checked })} ><small>Open in new tab?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    const drawForm = () => {

        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {/* BACKGROUND VIDEO */}
                {(mobile) ? drawMobile() : drawDesktop()}
            </>
        )

    }


    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}